export const getters = {
  STAT: state => state.statistics,
}
